import React from 'react';
import './ImageCards.css';

const ImageCards = () => {
  const cards = [
    {
      id: 1,
      title: 'Find Your',
      brand: 'Tulipink',
      subtitle: 'Florist',
      description: 'Connect with our network of professional florists',
      buttonText: 'Our Florists',
      image: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      overlayColor: '#8B0000',
      buttonColor: '#F8D3A0'
    },
    {
      id: 2,
      title: 'Sustainable',
      brand: 'Tulipink',
      subtitle: 'Professional',
      description: 'Eco-friendly practices and local sourcing',
      buttonText: 'More about sustainability',
      image: 'https://images.unsplash.com/photo-1518895949257-7621c3c786d7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      overlayColor: '#228B22',
      buttonColor: '#000000'
    }
  ];

  return (
    <section className="image-cards" aria-label="Featured Services">
      <div className="image-cards__container">
        <div className="image-cards__grid">
          {cards.map((card) => (
            <div key={card.id} className="image-card">
              <div className="image-card__container">
                <img 
                  src={card.image} 
                  alt={card.description}
                  className="image-card__image"
                />
                
                <div className="image-card__overlay">
                  <div 
                    className="image-card__text-overlay"
                    style={{ backgroundColor: card.overlayColor }}
                  >
                    <div className="text-content">
                      <span className="text-line-1">{card.title}</span>
                      <span className="text-line-2">{card.brand}</span>
                      <span className="text-line-3">{card.subtitle}</span>
                    </div>
                  </div>
                  
                  <div className="image-card__button-container">
                    <button 
                      className="image-card__button"
                      style={{ backgroundColor: card.buttonColor }}
                    >
                      <span className="button-text">{card.buttonText}</span>
                      <svg className="button-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M5 12h14"/>
                        <path d="M12 5l7 7-7 7"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImageCards;
